import React from 'react';
import { Link } from 'react-router-dom';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaWeixin, FaWeibo } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gray-900 text-white pt-10 pb-6">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company information */}
          <div>
            <h3 className="text-xl font-bold mb-4">五粮液专卖</h3>
            <p className="mb-2">南昌市玉洒贸易有限公司</p>
            <p className="mb-2 text-gray-400">五粮液官方授权店，提供正品保障</p>
            <ul className="mt-4">
              <li className="flex items-center mb-2">
                <FaPhone className="mr-2 text-red-700" />
                <span>+86 13907917041</span>
              </li>
              <li className="flex items-center mb-2">
                <FaEnvelope className="mr-2 text-red-700" />
                <span>info@ystrades.com</span>
              </li>
              <li className="flex items-center mb-2">
                <FaMapMarkerAlt className="mr-2 text-red-700" />
                <span>江西省南昌市西湖区</span>
              </li>
            </ul>
          </div>
          
          {/* Quick links */}
          <div>
            <h3 className="text-xl font-bold mb-4">快速链接</h3>
            <ul>
              <li className="mb-2">
                <Link to="/" className="hover:text-red-500">首页</Link>
              </li>
              <li className="mb-2">
                <Link to="/products" className="hover:text-red-500">产品</Link>
              </li>
              <li className="mb-2">
                <Link to="/about" className="hover:text-red-500">关于我们</Link>
              </li>
              <li className="mb-2">
                <Link to="/terms" className="hover:text-red-500">条款与条件</Link>
              </li>
              <li className="mb-2">
                <Link to="/privacy" className="hover:text-red-500">隐私政策</Link>
              </li>
            </ul>
          </div>
          
          {/* Social media and newsletter */}
          <div>
            <h3 className="text-xl font-bold mb-4">关注我们</h3>
            <div className="flex mb-6">
              <a href="#" className="mr-4 hover:text-red-500">
                <FaWeixin size={24} />
              </a>
            </div>
            
            
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-6 text-center text-gray-400">
          <p>© {currentYear} 南昌市玉洒贸易有限公司. 保留所有权利.</p>
          <p className="mt-2">五粮液官方授权店</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
